<template>
<div class="container">
  <div class="row">
        <div class="col">
          <h2 class="VIDEOS"> CLINICS<span class="alt-title"> / CONCERTS</span></h2>
        </div>
      </div>
  <!-- Example row of columns -->
  <div class="row">
    <div v-for="event in events"
         class="col-lg-4 col-md-6 col-sm-12 col-xs-12 Yevent">
      <div class="row boxevento" >
        <div class="col-4">
          <img class="event-image"
               :src="event.flayer">
        </div>
        <div class="col-8 eventDescription">
          <h2 class="title">{{event.title}}</h2>
          <p class="descripcion">{{event.description}}</p>
          <p class="date-info">{{event.date}}</p>
          <p class="date-info address-info">{{event.place}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /container -->

</template>

<script>
export default {
  name: 'name',
  data() {
    return {
      events: [
        {
          'title': 'Clínica',
          'description': 'Clínica de batería con Yilmer Vivas',
          'date': 'Monday, September 17 12 pm',
          'place': 'Universidad Libre de Música Av. Ignacio L. Vallarta 1543, Americana.',
          'linkbuy': '',
          'flayer': '/static/events/YilmerClinica1.png'
        },
        {
          'title': 'CONCIERTO',
          'description': 'Yilmer Vivas - Colors in My Mind',
          'date': 'Tuesday, September 18. 8 Pm',
          'place': 'Palíndromo, Café Libreria. Guadalajara',
          'linkbuy': '',
          'flayer': '/static/events/YilmerPalindromo.png'
        },
        {
          'title': 'Clínica',
          'description': 'Clínica de batería con Yilmer Vivas',
          'date': 'Monday, October 15. 16 Pm.',
          'place': 'Escuela Superior de Música y Danza de Monterrey . ',
          'linkbuy': '',
          'flayer': '/static/events/YilmeClinica2.png'
        }
      ]

    }
  }
}

</script>

<style scoped="">
@media (max-width: 1199px) {
  .event-image {
    width: 100%;
  }
}

@media (max-width: 991px) {
  .event-image {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .event-image {
    width: 100%;
  }
}


@media (max-width: 576px) {
    .descripcion {
        display: none;
    }
}

.VIDEOS {
  font-family: 'Open Sans', sans-serif;
  font-size: 35px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: rgb(0, 0, 0);
  color: var(--black);
  margin-bottom: 20px;
  margin-top: 30px;
}

.VIDEOS .alt-title {
  font-weight: normal;
}


.Yevent {
  padding: 10px;
}

.event-image {
  width: 110px;
  margin-top: 5px;
}

.container {
  margin-top: 120px;
}

.eventDescription{
  
}

.boxevento{
  //opacity: 0.6;
}
.date-info {
  text-transform: uppercase;
  text-align: left;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  margin-bottom: 2px;
  letter-spacing: 0.3px;
  color: rgb(0, 0, 0);
  color: var(--black);
}
.address-info {
  font-size: 10px;
}
.descripcion {
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  text-align: left;
  color: rgb(0, 0, 0);
  color: var(--black);
  height: 40px;
}

.title {
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: rgb(0, 0, 0);
  color: var(--black);

}
</style>



// WEBPACK FOOTER //
// src/components/YilmerEvents.vue